import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';

import theme from './theme';

/**
 * Styling-only providers. Lives *outside* ErrorBoundary so the fallback UI
 * always has the app's theme available, even if a downstream provider (auth,
 * query client, tenant context) throws during init.
 */
const ThemeProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

export default ThemeProviders;
